import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

//	///////////////////////
//	MARK: EXPORTS
// P6, P12 — le planning : la flotte, et le client pour ses avions (sans brouillon).
export const MaintenancePlannerRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance--fleet', 'role--maintenance--client']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
